import { useCallback, useEffect, useRef, useState } from "react";

const useContextMenu = () => {
  const elemRef = useRef();
  const [showMenu, setShowMenu] = useState({
    xPos: "0px",
    yPos: "0px",
    show: false,
    disable: false,
  });

  const handleContextMenu = useCallback((e) => {
    e.preventDefault();

    const target = e?.target;
    elemRef.current = target;

    const id = typeof target?.id === "string" ? target.id : "";
    const dataId = typeof target?.getAttribute === "function" ? target.getAttribute("data-id") : null;
    const parentId = typeof target?.parentElement?.id === "string" ? target.parentElement.id : "";

    const isElementActionable =
      Boolean(dataId) ||
      /title|text|layout|image/i.test(id) ||
      parentId.includes("image") ||
      parentId.includes("shape");

    setShowMenu({
      xPos: `${e.clientX}px`,
      yPos: `${e.clientY}px`,
      show: true,
      disable: !isElementActionable,
    });
  }, []);

  const handleClick = useCallback(() => {
    setShowMenu((prev) => (prev.show ? { ...prev, show: false, disable: false } : prev));
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClick);
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [handleClick, handleContextMenu]);

  return { showMenu, elemRef };
};

export default useContextMenu;
